import {
  reportIntentPages,
  type ReportIntentPageSlug,
} from "@ishvaram/domain-data/report-intent-pages";
import type { SEOIntent } from "@/lib/seo-intents";

export type ReportIntentSlug = ReportIntentPageSlug;

export interface ReportIntentConfig {
  readonly slug: ReportIntentSlug;
  readonly reportSlug: string;
  readonly intent: SEOIntent;
  readonly eyebrow: string;
  readonly title: string;
  readonly description: string;
  readonly lead: string;
  readonly checkpoints: readonly string[];
  readonly fit: string;
  readonly inputSurface: "kundali" | "matching";
  readonly offerHeadline: string;
  readonly offerSubhead: string;
  readonly collectInputsLabel: string;
  readonly customerProblem: string;
  readonly faq: readonly { readonly q: string; readonly a: string }[];
}

export const REPORT_INTENT_PAGES = reportIntentPages as Record<
  ReportIntentSlug,
  ReportIntentConfig
>;

export const REPORT_INTENT_SLUGS = Object.keys(REPORT_INTENT_PAGES) as ReportIntentSlug[];

// Route predicates live in `@/lib/report-intent-path` (slug-only projection)
// so the root layout's client graph never imports this module's page copy.
export { HINDI_REPORT_INTENT_SLUGS, isReportIntentLandingPath } from "@/lib/report-intent-path";
